import React, { ChangeEvent, ComponentType, ReactNode } from 'react';

import { Repository, Workspace } from 'src/components/types';

import { MenuItem, AnalyticsEvent } from '../../types';
import { AccountMenuProps } from '../account-menu';
import { AtlassianSwitcherProps } from '../atlassian-switcher/atlassian-switcher';
import { ContainerNavigationProps } from '../container-navigation-next';
import { ExternalHelpMenuProps } from '../help-menu';
import { SearchTargetUserProps } from '../index-next';

type BaseCreateDrawerProps = {
  containerBitbucketActions?: MenuItem[];
  containerConnectActions?: MenuItem[];
  drawerHeader?: ReactNode;
  globalBitbucketActions: MenuItem[];
  onCloneClick: () => void;
  onCreateDrawerClose: () => void;
  linkComponent?: ComponentType<any>;
  publishUiEvent: (event: AnalyticsEvent) => void;
};

type BaseGlobalSearchProps = SearchTargetUserProps & {
  currentProject?: BB.Project;
  repoSlug?: string;
  repoName?: string;
  linkComponent?: ComponentType<any>;
  onSearch?: (event: ChangeEvent) => void;
  onSearchDrawerInit?: () => void;
  onSearchSubmit?: () => void;
  recentlyViewed?: BB.Repository[];
  searchQuery?: string;
  repositoryLinkComponent?: ComponentType<any>;
  pullRequestLinkComponent?: ComponentType<any>;
  isLoggedIn: boolean;
  publishUiEvent: (event: AnalyticsEvent) => void;
  currentRepository?: Repository;
  currentWorkspace?: Workspace;
};

type GlobalSearchProps = BaseGlobalSearchProps & {
  onSearchDrawerClose: () => void;
  isSearchDrawerOpen: boolean;
};

export type HorizontalNavProps = BaseCreateDrawerProps &
  GlobalSearchProps &
  AccountMenuProps &
  ExternalHelpMenuProps &
  AtlassianSwitcherProps & {
    avatarUrl?: string;
    menuItems: {
      mainItems: MenuItem[];
      secondaryItems: MenuItem[];
      settingsItems: MenuItem[];
    };
    adminHubUrl?: string;
    attributionsUrl?: string;
    whatsNewUrl?: string;
    useContainerNavigationProps?: () => ContainerNavigationProps;
    handleProductClick: (e: React.MouseEvent) => void;
    onSearchDrawerOpen?: () => void;
    environment: string;
    isWorkspaceAdmin?: boolean;
    isNavThemeSelectorEnabled?: boolean;
  };

export const HorizontalNavContext = React.createContext<HorizontalNavProps>({
  globalBitbucketActions: [],
  onCloneClick: () => {},
  onCreateDrawerClose: () => {},
  onSearchDrawerClose: () => {},
  onSearchDrawerOpen: () => {},
  isSearchDrawerOpen: false,
  isLoggedIn: false,
  userAvatarUrl: undefined,
  userDisplayName: undefined,
  userUuid: undefined,
  userWorkspaceId: undefined,
  menuItems: {
    mainItems: [],
    secondaryItems: [],
    settingsItems: [],
  },
  onKeyboardShortcutsActivated: () => {},
  onFeedbackModalOpen: () => {},
  onToggleAtlassianSwitcher: () => {},
  isAtlassianSwitcherOpen: false,
  publishUiEvent: () => {},
  handleProductClick: () => {},
  workspaceLinkComponent: undefined,
  currentWorkspace: undefined,
  currentRepository: undefined,
  environment: 'staging',
});
